import request from "./axios";

/**
 * 报名赛事
 * @param {*} contestId 
 * @param {*} studentName 
 * @param {*} instructor 
 * @param {*} phone 
 */
export function saveContestApply(contestId, studentName, instructor, phone){
    return request({
        url: "/api/teaching/teachingContest/saveContestApply",
        method: "post",
        data:{
            contestId: contestId,
            studentName: studentName,
            instructor: instructor,
            phone: phone
        }
    })
}
/**
 * 赛事列表
 */
export function contestList(contestStatus){
    return request({
        url: "/api/teaching/teachingContest/list",
        method: "get",
        params: {
            contestStatus
        }
    })
}

/**
 * 赛事详情
 */
export function contestDetail(contestId){
    return request({
        url: "/api/teaching/teachingContest/queryById?id="+contestId,
        method: "get"
    })
}

/**
 * 获取比赛用户排名 （按点赞）
 */
export function getUserContestRank(){
    return request({
        url: "/api/teaching/teachingContest/getUserRank",
        method: "get"
    })
}

/**
 * 获奖作品
 */
export function getContestWinWork(){
    return request({
        url: "/api/teaching/teachingContestWinWork/list",
        method: "get"
    })
}


// WEBPACK FOOTER //
// ./src/api/contest.js